import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import {
    passwordGuess,
    passwordLength,
    passwordLetters,
    passwordNumbers,
    passwordRepetitive,
    passwordSymbols,
    passwordWhiteSpace,
    RULE_STATUS,
} from '../../utils/CreateAccountValidation/constants';
import CreatePasswordRulesListItem from './CreatePasswordRulesListItem';

/**
 * @param {boolean} animateRuleListAppearance
 * @param {boolean} inBooking
 * @param {Object} statusChecks
 * @returns {JSX.Element}
 * @constructor
 */
export default class PasswordRules extends Component {
    render() {
        const { inBooking, statusChecks, animateRuleListAppearance } =
            this.props;

        const List = animateRuleListAppearance
            ? RuleListWithAnimation
            : RulesList;
        return (
            <PasswordRulesBody data-test="password-rules-body">
                <List>
                    <CreatePasswordRulesListItem
                        inBooking={inBooking}
                        status={statusChecks[passwordLength]}
                        message={'Use at least 8 characters'}
                        datatest={'eight-chars'}
                    />

                    <CreatePasswordRulesListItem
                        inBooking={inBooking}
                        status={statusChecks[passwordLetters]}
                        message={'Use letters'}
                        datatest={'use-letters'}
                    />

                    <CreatePasswordRulesListItem
                        inBooking={inBooking}
                        status={statusChecks[passwordNumbers]}
                        message={'Use numbers'}
                        datatest={'use-numbers'}
                    />

                    <CreatePasswordRulesListItem
                        inBooking={inBooking}
                        status={statusChecks[passwordSymbols]}
                        message={'Use special characters, like @#$%&*'}
                        datatest={'use-symbols'}
                    />

                    {statusChecks[passwordGuess] === RULE_STATUS.INVALID && (
                        <CreatePasswordRulesListItem
                            inBooking={inBooking}
                            status={RULE_STATUS.INVALID}
                            message={'Password cannot be easy to guess'}
                            datatest={'easy-guess'}
                        />
                    )}

                    {statusChecks[passwordWhiteSpace] ===
                        RULE_STATUS.INVALID && (
                        <CreatePasswordRulesListItem
                            inBooking={inBooking}
                            status={RULE_STATUS.INVALID}
                            message={'Password must not contain any spaces'}
                            datatest={'white-space'}
                        />
                    )}

                    {statusChecks[passwordRepetitive] ===
                        RULE_STATUS.INVALID && (
                        <CreatePasswordRulesListItem
                            inBooking={inBooking}
                            status={RULE_STATUS.INVALID}
                            message={
                                "Don't use the same character 4 times in a row"
                            }
                            datatest={'same-char'}
                        />
                    )}
                </List>
            </PasswordRulesBody>
        );
    }
}

const fadeIn = keyframes`
    from { opacity: 0.01; }
    to {  opacity: 1; }
`;

const PasswordRulesBody = styled.div`
    font: 13px/24px ${FontFamily.SharpSansMedium};
    overflow: hidden;
    margin-top: 11px;
    min-width: 276px;
    z-index: 0;
`;

const RulesList = styled.ul`
    list-style-position: inside;
    list-style-type: disc;
    padding: 0;
    margin: 0;
`;

const RuleListWithAnimation = styled(RulesList)`
    animation: 0.25s ${fadeIn} ease-in 1 forwards;
`;
